import { render, staticRenderFns } from "./GoodStanding.vue?vue&type=template&id=795f6547&scoped=true"
import script from "./GoodStanding.vue?vue&type=script&lang=js"
export * from "./GoodStanding.vue?vue&type=script&lang=js"
import style0 from "./GoodStanding.vue?vue&type=style&index=0&id=795f6547&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795f6547",
  null
  
)

export default component.exports